
import  './LatestVehiclesSlider.scss';
import Image from 'next/image';

export default function LatestVehicleCard() {
    return (
      <>
        <a href="">
            <div className="l-node-used-vehicle--latest-vehicles">
                <div className="l-node-used-vehicle--latest-vehicles__photo">
                    <div className="image-wrap">
                    <Image
                        src={'/home-slider/slide1.jpg'}
                        alt="Slide 1"
                        fill
                        style={{ objectFit: 'cover' }}
                        />
                    </div>
                </div>
                <div className="l-node-used-vehicle--latest-vehicles__main-content">
                    <div className="l-node-used-vehicle--latest-vehicles__main-content--inner">

                        <div className="l-node-used-vehicle--latest-vehicles__title-wrap">
                        <div className="l-node-used-vehicle--latest-vehicles__logo">
                            <img src="https://s3.eu-west-1.amazonaws.com/processed-files.autopromotor.co.uk/shared/manufacturer-logos/volkswagen_light.png" data-placeholder="https://s3.eu-west-1.amazonaws.com/processed-files.autopromotor.co.uk/shared/body-type-logos/unknown-body-type.svg" alt="Volkswagen" loading="lazy" />
                            <div className="swiper-lazy-preloader"></div>
                        </div>
                        <div className="l-node-used-vehicle--latest-vehicles__make-model">
                            <div className="field field-name-make-model">
                            Vauxhall Astra
                            </div>
                            <div className="field field-name-derivative">
                            1.5 TDci Powershift
                            </div>
                        </div>
                        </div>

                        <div className="l-node-used-vehicle--latest-vehicles__spec">
                        <ul className="field-name-spec">
                            <li>%vehicle_year%</li>
                            <li>%vehicle_mileage%</li>
                            <li>%vehicle_transmission%</li>
                            <li>%vehicle_fuel%</li>
                        </ul>
                        </div>


                        </div>

                        <div className="l-node-used-vehicle--latest-vehicles__price-wrap">
         
                            <div className="l-node-used-vehicle--latest-vehicles__price">
                                <div>
                                    <div className="field-name-vehicle-price">£11,995</div>
                                </div>
                            </div>
                    
                            <div className="l-node-used-vehicle--latest-vehicles__monthly-price">
                                <div className="field-name-vehicle-price field-name-vehicle-monthly-price">
                                    <div className="label-inline">Monthly From</div>£100.99
                                </div>
                            </div>

                        </div>



                </div>
            </div>
        </a>
      </>
    );
  }
  

